import { render, staticRenderFns } from "./PaymentInstructionList.vue?vue&type=template&id=8051551e&scoped=true&"
import script from "./PaymentInstructionList.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructionList.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInstructionList.vue?vue&type=style&index=0&id=8051551e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8051551e",
  null
  
)

export default component.exports